(() => {
  const badges = Array.from(document.querySelectorAll('.cz-sale-toggle'));
  if (!badges.length) return;

  const CYCLE_MS = 2040;
  const OFFER_START_MS = CYCLE_MS * 0.215;
  const SALE_START_MS = CYCLE_MS * 0.725;
  const ENTRY_MS = CYCLE_MS * 0.12;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const timers = new Set();

  const copy = {
    sale: 'SALE',
    offer: 'UP TO 20% OFF'
  };

  const setLayer = (layer, kind) => {
    if (!layer) return;
    layer.dataset.czSaleKind = kind;
    layer.textContent = copy[kind];
  };

  const setBase = (kind) => {
    badges.forEach((badge) => setLayer(badge.querySelector('.cz-sale-toggle__base'), kind));
  };

  const clearTimers = () => {
    timers.forEach((timer) => window.clearTimeout(timer));
    timers.clear();
  };

  const schedule = (callback, delay) => {
    const timer = window.setTimeout(() => {
      timers.delete(timer);
      callback();
    }, delay);
    timers.add(timer);
    return timer;
  };

  const resetOverlays = (kind = 'offer') => {
    badges.forEach((badge) => {
      const overlay = badge.querySelector('.cz-sale-toggle__overlay');
      if (!overlay) return;
      overlay.classList.remove('is-entering');
      setLayer(overlay, kind);
    });
  };

  const enterFromTop = (kind) => {
    if (document.hidden || reducedMotion.matches) {
      reset();
      return;
    }

    badges.forEach((badge) => {
      const overlay = badge.querySelector('.cz-sale-toggle__overlay');
      if (!overlay) return;
      overlay.classList.remove('is-entering');
      setLayer(overlay, kind);
      void overlay.offsetWidth;
      overlay.classList.add('is-entering');
    });

    schedule(() => {
      setBase(kind);
      resetOverlays(kind === 'offer' ? 'sale' : 'offer');
    }, ENTRY_MS);
  };

  const runCycle = () => {
    schedule(() => enterFromTop('offer'), OFFER_START_MS);
    schedule(() => enterFromTop('sale'), SALE_START_MS);
    schedule(runCycle, CYCLE_MS);
  };

  const reset = () => {
    clearTimers();
    resetOverlays('offer');
    setBase(reducedMotion.matches || document.hidden ? 'offer' : 'sale');
    if (!reducedMotion.matches && !document.hidden) runCycle();
  };

  reducedMotion.addEventListener?.('change', reset);
  document.addEventListener('visibilitychange', reset);
  reset();
})();
